import React from "react";
import Layout from "../../layouts/Layout";
import Button from "@mui/material/Button";
class About extends React.Component {
  render() {
    return (
      <Layout>
        <div>About</div>
        <Button variant="contained">Hello World</Button>
      </Layout>
    );
  }
}
export default About;
